import type { InterestRegistrationRequest } from './types'

export async function registerInterest(
  companySlug: string,
  request: InterestRegistrationRequest
): Promise<void> {
  if (
    import.meta.env.DEV &&
    import.meta.env.VITE_REGISTER_INTEREST_MODE === 'mock'
  ) {
    await new Promise((resolve) => window.setTimeout(resolve, 350))
    return
  }

  const response = await fetch(
    `/v1/investor-relations/${encodeURIComponent(
      companySlug
    )}/register-interest`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    }
  )
  if (!response.ok) {
    throw new Error('Registration could not be completed. Please try again.')
  }
}
